export default "__VITE_ASSET__DQD1H8Qz__"